import { apiClient } from '@/utils/api'

export interface ProviderInfo {
  provider: 'google' | 'facebook' | 'apple' | 'auth0'
  displayName: string
}

export interface UserProfile {
  userId: string
  email?: string
  displayName: string
  picture?: string
  provider?: ProviderInfo
  createdAt: string
  updatedAt: string
}

export interface UserHints {
  // Not stored in DB; used only for UI prefill / display.
  email?: string
  name?: string
  picture?: string
}

interface ProfileResponse {
  data: UserProfile
}

export const profileService = {
  async get(): Promise<UserProfile> {
    const response = await apiClient.authGet<ProfileResponse>('/profile')
    return response.data
  },

  async create(data: { displayName?: string; picture?: string }): Promise<UserProfile> {
    const response = await apiClient.authPost<ProfileResponse>('/profile', data)
    return response.data
  },

  async update(data: Partial<Pick<UserProfile, 'displayName' | 'picture'>>): Promise<UserProfile> {
    const response = await apiClient.authPut<ProfileResponse>('/profile', data)
    return response.data
  },
}
